import { getStoreState } from '@cogitate/ui-multi-utils/dist/utilities/pages/shared';
import { storeKeys } from 'ui/data/constants/keys';

const MASTER_API_REQUIRES_TOKEN = 'Master API requires logged-in user token';

/**
 * Headers for authenticated GET requests to api/master.
 * @returns {{ Authorization: string, 'Ocp-Apim-Subscription-Key': string }}
 */
export function getMasterCallHeaders() {
  const encodedJWT = getStoreState(storeKeys.LoggedInUserReducer)?.encodedJWT;
  if (typeof encodedJWT !== 'string' || encodedJWT.length === 0) {
    throw new Error(MASTER_API_REQUIRES_TOKEN);
  }

  return {
    Authorization: `Bearer ${encodedJWT}`,
    'Ocp-Apim-Subscription-Key':
      process.env.NEXT_PUBLIC_ADAPTIVE_SUBSCRIPTION_KEY,
  };
}
